/* global femcare */

femcare.ctaPanel.quickBuy = {
    $quickBuyButton: $('.cta-panel .cta-panel__quick-buy-button'),
    productsData: window.pr_render_quick_buy_data ,
    $quickBuyModal: $('#cta-panel__quick-buy-modal'),

    init: function() {
        this.isSearchPage();
        
        if(this.$quickBuyButton.length && this.productsData.length) {
            this.openModal();
            this.closeModal();
        }
    },

    generateModal: function(id) {
        var $modal = this.$quickBuyModal;

        this.productsData.forEach(function(element, index){
            var productId = element.ProductId;

            if(productId === id) {
                var productContent = element.detailQuickBuyHtml ;
                var parser = new DOMParser();
                var parsedContent = parser.parseFromString(productContent, "text/html");
                var contentToUse = parsedContent.activeElement;
                $modal.find('.cta-panel__quick-buy-modal--content').html(contentToUse);

                return;
            }
        })
            
        var $product = $modal.find('.product-main--shop-slim');
        femcare.product.panel.info.shop.mainPanelSlim($product);
        var productId = $product[0].dataset.productid;
        var productReviewComponent = $product[0].dataset.productReviewComponents;
        
        this.renderPowerReviews(productId, productReviewComponent);
    },

    openModal: function(){
        this.$quickBuyButton.on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            var productId = e.target.dataset.productid;
            this.$quickBuyModal.show();
            this.generateModal(productId);
        }.bind(this))
    }, 

    closeModal: function(){
        var $closeModal = $('.cta-panel__quick-buy-close .icon-close');

        $closeModal.on('click', function(e){
            e.stopPropagation();    
            e.preventDefault();
           
            this.$quickBuyModal.hide();
        }.bind(this))
    },

    renderPowerReviews: function (productId, productReviewComponent){
        var isPowerReviewsLoaded = window.POWERREVIEWS;
        if(isPowerReviewsLoaded){
            var pr_render_options = window.pr_render_options || []
            pr_render_options.forEach(function(element, index){
                var reviewSnippetId = pr_render_options[index].page_id;

                if (reviewSnippetId === productId) {
                    var renderData = pr_render_options[index];
                    var componentsData = JSON.parse(productReviewComponent)
                    renderData.components = componentsData;
                    window.POWERREVIEWS.display.render(renderData);
                }
            })
        }
    },

    isSearchPage: function() {
        var searchPageIndicator = $('.search-results');

        if (searchPageIndicator.length) {
            this.$quickBuyButton = $('.cta-panel .cta-panel__quick-buy-button');
        }
    }
}